import { all, takeEvery, takeLatest } from 'redux-saga/effects';

import * as actions from './actions';

import {
  searchPatientHistorySaga,
  getPatientRoundHistorySaga,
  getEmployeeRoundHistorySaga,
  getComplianceReportSaga,
  getEmpComplianceReportSaga,
  getPatientRoundsReportSaga,
  getPatientRoundsReportDownloadSaga,
  getCensusReportDownloadSaga,
  getCensusReportSaga,
  getEmployeeRoundsReportSaga,
  getEmployeeRoundsReportDownloadSaga,
  getEmployeeFreqReportSaga,
  getEmployeeFreqReportDownloadSaga
} from './saga/Report.saga';
import { postRoundSaga, getRoundSaga } from './saga/Round.saga';
import {
  getStoplightByIdSaga,
  postNewStoplightSaga,
  updateStoplightSaga,
  deleteStoplightSaga,
  postCommentToStoplightSaga,
  getStoplightsByLocationSaga,
  getStoplightsByLocationDownloadSaga,
  searchStoplightsSaga,
  shareStoplightSaga
} from './saga/Stoplight.saga';
import {
  postNewTaskSaga,
  completeTaskSaga,
  deleteTaskSaga,
  getCategoriesByTypeSaga,
  getDetailsByTicketNumSaga,
  getSCLocationsSaga,
  getGELocationsSaga,
  verifyControlNumberSaga,
  getTaskDiscussionSaga,
  postCommentToTaskSaga,
  searchIssuesSaga,
  getIssuesByUnitIdsOrEmployeeListSaga,
  getIssuesByUnitIdsOrEmployeeListDownloadSaga,
  getIssueReportByFacilityIdSaga,
  getIssueReportByFacilityIdDownloadSaga,
  getFeedbackByUnitIdsSaga,
  getFeedbackByEmployeeListSaga,
  getFeedbackByUnitIdsOrEmployeeListDownloadSaga,
  getFeedbackReportByFacilityIdSaga,
  getFeedbackReportByFacilityIdDownloadSaga,
  shareAllTasksSaga,
  getTasksByAccountNumSaga,
  getTasksByEmployeeIdSaga
} from './saga/Task.saga';

// eslint-disable-next-line func-names
export default function* () {
  return yield all([
    // Report watches
    takeEvery(actions.searchPatientHistory.type, searchPatientHistorySaga),
    takeEvery(actions.getPatientRoundHistory.type, getPatientRoundHistorySaga),
    takeEvery(
      actions.getEmployeeRoundHistory.type,
      getEmployeeRoundHistorySaga
    ),
    takeEvery(actions.getComplianceReport.type, getComplianceReportSaga),
    takeEvery(actions.getEmpComplianceReport.type, getEmpComplianceReportSaga),
    takeLatest(actions.getPatientRoundsReport.type, getPatientRoundsReportSaga),
    takeLatest(
      actions.getPatientRoundsReportDownload.type,
      getPatientRoundsReportDownloadSaga
    ),
    takeEvery(actions.getCensusReport.type, getCensusReportSaga),
    takeEvery(
      actions.getCensusReportDownload.type,
      getCensusReportDownloadSaga
    ),
    takeEvery(actions.getCensusReportExport.type, getCensusReportDownloadSaga),
    takeLatest(
      actions.getEmployeeRoundsReport.type,
      getEmployeeRoundsReportSaga
    ),
    takeLatest(
      actions.getEmployeeRoundsReportDownload.type,
      getEmployeeRoundsReportDownloadSaga
    ),
    takeLatest(actions.getEmployeeFreqReport.type, getEmployeeFreqReportSaga),
    takeLatest(
      actions.getEmployeeFreqReportDownload.type,
      getEmployeeFreqReportDownloadSaga
    ),

    // Round actions
    takeEvery(actions.postRound.type, postRoundSaga),
    takeLatest(actions.getRound.type, getRoundSaga),

    // Stoplight watches
    takeEvery(actions.getStoplightById.type, getStoplightByIdSaga),
    takeEvery(actions.postNewStoplight.type, postNewStoplightSaga),
    takeEvery(actions.updateStoplight.type, updateStoplightSaga),
    takeEvery(actions.deleteStoplight.type, deleteStoplightSaga),
    takeEvery(actions.postCommentToStoplight.type, postCommentToStoplightSaga),
    takeEvery(
      actions.getStoplightsByLocation.type,
      getStoplightsByLocationSaga
    ),
    takeEvery(
      actions.getStoplightsByLocationDownload.type,
      getStoplightsByLocationDownloadSaga
    ),
    takeEvery(actions.searchStoplights.type, searchStoplightsSaga),
    takeEvery(actions.shareStoplight.type, shareStoplightSaga),

    // Task watches
    takeEvery(actions.postNewTask.type, postNewTaskSaga),
    takeEvery(actions.completeTask.type, completeTaskSaga),
    takeEvery(actions.deleteTask.type, deleteTaskSaga),
    takeEvery(actions.getCategoriesByType.type, getCategoriesByTypeSaga),
    takeEvery(actions.getDetailsByTicketNum.type, getDetailsByTicketNumSaga),
    takeEvery(actions.getSCLocations.type, getSCLocationsSaga),
    takeEvery(actions.getGELocations.type, getGELocationsSaga),
    takeEvery(actions.verifyControlNumber.type, verifyControlNumberSaga),
    takeEvery(actions.getTaskDiscussion.type, getTaskDiscussionSaga),
    takeEvery(actions.postTaskComment.type, postCommentToTaskSaga),
    takeEvery(actions.searchIssues.type, searchIssuesSaga),
    takeEvery(
      actions.getIssuesByUnitIdsOrEmployeeList.type,
      getIssuesByUnitIdsOrEmployeeListSaga
    ),
    takeEvery(
      actions.getIssuesByUnitIdsOrEmployeeListDownload.type,
      getIssuesByUnitIdsOrEmployeeListDownloadSaga
    ),
    takeEvery(
      actions.getIssueReportByFacilityId.type,
      getIssueReportByFacilityIdSaga
    ),
    takeEvery(
      actions.getIssueReportByFacilityIdDownload.type,
      getIssueReportByFacilityIdDownloadSaga
    ),
    takeEvery(actions.getFeedbackByUnitIds.type, getFeedbackByUnitIdsSaga),
    takeEvery(
      actions.getFeedbackByEmployeeList.type,
      getFeedbackByEmployeeListSaga
    ),
    takeEvery(
      actions.getFeedbackByUnitIdsOrEmployeeListDownload.type,
      getFeedbackByUnitIdsOrEmployeeListDownloadSaga
    ),
    takeEvery(
      actions.getFeedbackReportByFacilityId.type,
      getFeedbackReportByFacilityIdSaga
    ),
    takeEvery(
      actions.getFeedbackReportByFacilityIdDownload.type,
      getFeedbackReportByFacilityIdDownloadSaga
    ),
    takeEvery(actions.shareAllTasks.type, shareAllTasksSaga),
    takeEvery(actions.getTasksByAccountNum.type, getTasksByAccountNumSaga),
    takeEvery(actions.getTasksByEmployeeId.type, getTasksByEmployeeIdSaga)
  ]);
}
